import React, { useState, useEffect } from "react";
import "./App.css";
import { Link, Redirect, useLocation, useHistory } from "react-router-dom";
import Axios from "axios";
import Select from "react-select";
import {
  IoIosArrowBack,
  IoIosCheckmarkCircleOutline,
  IoIosRadioButtonOff,
} from "react-icons/io";
import ClipLoader from "react-spinners/ClipLoader";
import Header3 from "./components/Header3";
import TopBarProgress from "react-topbar-progress-indicator";
import NumberFormat from "react-number-format";
import { ImMan } from "react-icons/im";
import { FaChild } from "react-icons/fa";
import Header from "./layouts/Header";
import SideNav from "./layouts/SideNav";
import { BiMenu } from "react-icons/bi";

const Downloadtickets = () => {
  const location = useLocation();
  const history = useHistory();
  const { eventid } = location.state || {};
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [successError, setSuccessError] = useState("error-login");
  const [errorDisplay, setErrorDisplay] = useState("none");
  const [businessname, setBusinessname] = useState(
    localStorage.getItem("businessname")
  );

  const [tickets, setTickets] = useState("");
  const [spinning, setSpinning] = useState("none");
  const [updateDisplay, setUpdateDisplay] = useState("block");
  const [eventtype, setEventtype] = useState("");
  const [ticketCategory, setTicketCategory] = useState([]);
  const [unchecked, setUnchecked] = useState(true);
  const [checked, setChecked] = useState(false);
  const [select, setSelect] = useState("item-select");

  const [ticketCount, setTicketCount] = useState(0);
  const [progressbar, setProgressbar] = useState(false);
  const [prepareCount, setPrepareCount] = useState(0);
  const [budget, setBudget] = useState(0);
  const [balance, setBalance] = useState(0);
  const [ticketPrint, setTicketPrint] = useState(0);
  const [estimatedRevenue, setEstimatedRevenue] = useState(0);
  const [kidsTicketPrint, setKidsTicketPrint] = useState(0);
  const [kidsEstimatedRevenue, setKidsEstimatedRevenue] = useState(0);
  const [ticket_category, setTicket_category] = useState([]);
  const [count, setCount] = useState(0);

  const isMobile = window.innerWidth <= 768;
  const [isMob, setIsMob] = useState();
  const [collapsed, setCollapsed] = useState(isMobile);

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768;
    setIsMob(mobile);
    setCollapsed((prev) => (mobile ? true : prev));
  };

  // if (location === null) {
  //   return <Redirect to="/dashboard" />;
  // }

  useEffect(() => {
    if (!location.state || !location.state.eventid) {
      history.push("/dashboard");
      return;
    }

    const businessid = localStorage.getItem("businessid");
    document.title = "Prepare tickets - Karamale";

    // GETBUDGET
    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=GETBUDGET&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      setBudget(response.data.budget);
      setBalance(response.data.balance);
    });

    // PREPAREDOWNLOADS
    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=PREPAREDOWNLOADS&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      setPrepareCount(response.data.prepareCount);
      setTicketPrint(response.data.ticketPrint);
      setEstimatedRevenue(response.data.estimatedRevenue);
    });

    // TICKETSTATUS
    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=TICKETSTATUS&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      setTicketCount(response.data.ticketCount);
    });

    // PREPARETICKETS
    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=PREPARETICKETS&eventid=${eventid}&businessid=${businessid}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      if (response.data.data === 0) {
        setTicketCategory([]);
      } else {
        setTicketCategory(response.data);
      }
    });

    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);

    return () => {
      // this runs on unmount
      window.removeEventListener("resize", updateIsMobile);
    };
  }, [count]);

  const increase = () => {
    const eventid = location.state.eventid;
    const eventname = location.state.eventname;
    const prevpage = location.state.prevpage;
    const currentpage = "editevent";
    const eventdate = location.state.eventdate;
    const poster = location.state.poster;
    const theme = location.state.theme;
    const venue = location.state.venue;
    const expectednum = location.state.expectednum;
    const enddate = location.state.enddate;
    const time = location.state.time;
    const endtime = location.state.endtime;
    const event_date = location.state.event_date;
    const finish_date = location.state.finish_date;
    history.push({
      pathname: "campaign",
      state: {
        eventid: eventid,
        eventname: eventname,
        poster: poster,
        eventdate: eventdate,
        enddate: enddate,
        event_date: event_date,
        finish_date: finish_date,
        theme: theme,
        venue: venue,
        expectednum: expectednum,
        time: time,
        endtime: endtime,
        prevpage: prevpage,
        currentpage: currentpage,
      },
    });
  };

  const handle_kids_tickets =
    (ticketid, category, instock, price, group) => (event) => {
      setTimeout(() => {
        setErrorDisplay("none");
      }, 4000);

      const eventid = location.state.eventid;
      if (parseInt(event.target.value) > parseInt(instock)) {
        if (instock === 0) {
          setErrorDisplay("block");
          setError(
            <label className="mb-0">
              {`${category} tickets for kids are out of stock`}
            </label>
          );
          setSuccessError("error-login");
        } else {
          setErrorDisplay("block");
          setError(
            <label className="mb-0">
              {`Only ${instock} tickets available for ${category}`}
            </label>
          );
          setSuccessError("error-login");
        }
      } else {
        setErrorDisplay("none");
        setTickets(event.target.value);

        Axios.get(
          "https://karamale.com/apps/kscanner/webservices.php?query=PREPARETICKETSDOWNLOAD&ticketid=" +
            ticketid +
            "&instock=" +
            instock +
            "&eventid=" +
            eventid +
            "&ticketsNumber=" +
            event.target.value +
            "&price=" +
            price +
            "&group=" +
            group,
          { withCredentials: true }
        ).then((response) => {
          setPrepareCount(response.data.prepareCount);
          setTicketPrint(response.data.ticketPrint);
          // setEstimatedRevenue(parseInt(response.data.estimatedRevenue));
          setEstimatedRevenue(parseInt(response.data.total_revenue));

          // If you're not using kids_prepare_count, you can omit it
          setKidsTicketPrint(response.data.kids_ticket_print);
          setKidsEstimatedRevenue(response.data.kids_estimated_revenue);
          setCount(count + 1);
        });
      }

      const eventname = location.state.eventname;
      const prevpage = location.state.prevpage;
      const currentpage = "editevent";
      const eventdate = location.state.eventdate;
      const poster = location.state.poster;
      const theme = location.state.theme;
      const venue = location.state.venue;
      const expectednum = location.state.expectednum;
      const enddate = location.state.enddate;
      const time = location.state.time;
      const endtime = location.state.endtime;
      const event_date = location.state.event_date;
      const finish_date = location.state.finish_date;

      history.push({
        pathname: "/downloadtickets",
        state: {
          eventid: eventid,
          eventname: eventname,
          poster: poster,
          eventdate: eventdate,
          enddate: enddate,
          event_date: event_date,
          finish_date: finish_date,
          theme: theme,
          venue: venue,
          expectednum: expectednum,
          time: time,
          endtime: endtime,
          prevpage: prevpage,
          currentpage: currentpage,
        },
      });
    };

  const handleTickets =
    (ticketid, category, instock, price, group) => (event) => {
      setTimeout(() => {
        setErrorDisplay("none");
      }, 4000);

      const eventid = location.state.eventid;
      if (parseInt(event.target.value) > parseInt(instock)) {
        setErrorDisplay("block");
        setSuccessError("error-login");

        if (instock === 0) {
          setError(
            <label className="mb-0">
              {`${category} tickets for adults are out of stock`}
            </label>
          );
        } else {
          setError(
            <label className="mb-0">
              {`Only ${instock} tickets available for ${category}`}
            </label>
          );
        }
      } else {
        setErrorDisplay("none");
        setTickets(event.target.value);

        Axios.get(
          "https://karamale.com/apps/kscanner/webservices.php?query=PREPARETICKETSDOWNLOAD&ticketid=" +
            ticketid +
            "&instock=" +
            instock +
            "&eventid=" +
            eventid +
            "&ticketsNumber=" +
            event.target.value +
            "&price=" +
            price +
            "&group=" +
            group,
          { withCredentials: true }
        ).then((response) => {
          setCount(count + 1);
          setPrepareCount(response.data.prepareCount);
          setTicketPrint(response.data.ticketPrint);
          // setEstimatedRevenue(parseInt(response.data.estimatedRevenue));
          setEstimatedRevenue(parseInt(response.data.total_revenue));

          // If you're not using kids_prepare_count, you can omit it
          setKidsTicketPrint(response.data.kids_ticket_print);
          setKidsEstimatedRevenue(response.data.kids_estimated_revenue);
        });
      }

      const eventname = location.state.eventname;
      const prevpage = location.state.prevpage;
      const currentpage = "editevent";
      const eventdate = location.state.eventdate;
      const poster = location.state.poster;
      const theme = location.state.theme;
      const venue = location.state.venue;
      const expectednum = location.state.expectednum;
      const enddate = location.state.enddate;
      const time = location.state.time;
      const endtime = location.state.endtime;
      const event_date = location.state.event_date;
      const finish_date = location.state.finish_date;

      history.push({
        pathname: "/downloadtickets",
        state: {
          eventid: eventid,
          eventname: eventname,
          poster: poster,
          eventdate: eventdate,
          enddate: enddate,
          event_date: event_date,
          finish_date: finish_date,
          theme: theme,
          venue: venue,
          expectednum: expectednum,
          time: time,
          endtime: endtime,
          prevpage: prevpage,
          currentpage: currentpage,
        },
      });
    };

  const handleChange = (e) => {
    setEventtype(e.value);
  };

  const selected = (ticketid, checked) => {
    setProgressbar(true);

    const eventid = location.state.eventid;
    const eventname = location.state.eventname;
    const prevpage = location.state.prevpage;
    const currentpage = "editevent";
    const eventdate = location.state.eventdate;
    const poster = location.state.poster;
    const theme = location.state.theme;
    const venue = location.state.venue;
    const expectednum = location.state.expectednum;
    const enddate = location.state.enddate;
    const time = location.state.time;
    const endtime = location.state.endtime;
    const event_date = location.state.event_date;
    const finish_date = location.state.finish_date;

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=MARKTICKETCATEGORY&ticketid=" +
        ticketid +
        "&eventid=" +
        eventid,
      { withCredentials: true }
    ).then((response) => {
      setTicketCount(response.data.ticketCount);
      setTicketPrint(response.data.ticketPrint);
      setPrepareCount(response.data.prepareCount);
      setProgressbar(false);
      setCount(count + 1);
    });

    history.push({
      pathname: "/downloadtickets",
      state: {
        eventid: eventid,
        eventname: eventname,
        poster: poster,
        eventdate: eventdate,
        enddate: enddate,
        event_date: event_date,
        finish_date: finish_date,
        theme: theme,
        venue: venue,
        expectednum: expectednum,
        time: time,
        endtime: endtime,
        prevpage: prevpage,
        currentpage: currentpage,
      },
    });
  };

  const ticketsF = () => {
    // const { unchecked, checked } = this.state;

    return (
      <div className="row justify-content-center">
        {ticketCategory.map((item, index) => {
          return (
            <div className="col-12">
              <div className="col-12 mb-3 text-right p-0">
                {item.checked == 1 ? (
                  <span>
                    <label className="mb-0 small-details font-size-13">
                      <span>R{item.ticket_price}</span> - How many{" "}
                      {item.category == "general"
                        ? "General"
                        : item.category == "vip"
                        ? "VIP"
                        : "VVIP"}
                      s ? <ImMan color={"darkorange"} />
                    </label>
                    <input
                      type="number"
                      min={0}
                      max={item.instock}
                      style={{
                        width: 150,
                        height: 40,
                      }}
                      className="edit-input ml-2"
                      placeholder={"Max of " + item.instock}
                      autoFocus
                      onChange={handleTickets(
                        item.ticketid,
                        item.category,
                        item.instock,
                        item.ticket_price,
                        "adults"
                      )}
                      defaultValue={
                        item.executed == 1
                          ? ""
                          : item.ticket_number < 1
                          ? ""
                          : item.ticket_number
                      }
                    />
                    <br />
                    <label className="small-details font-size-13">
                      Estimated revenue: R
                      {item.executed == 1
                        ? 0.0
                        : item.ticket_number == 0
                        ? 0
                        : item.revenues}
                    </label>
                    <br />
                    <label className="mb-0 small-details font-size-13">
                      <span>R{item.kids_ticket_price}</span> - How many{" "}
                      {item.category == "general"
                        ? "Gen"
                        : item.category == "vip"
                        ? "VIP"
                        : "VVIP"}
                      s ? <FaChild color={"#39c"} />
                    </label>
                    <input
                      type="number"
                      min={0}
                      max={item.kids_instock}
                      style={{
                        width: 150,
                        height: 40,
                      }}
                      className="edit-input ml-2"
                      placeholder={"Max of " + item.kids_instock}
                      autoFocus
                      onChange={handle_kids_tickets(
                        item.ticketid,
                        item.category,
                        item.kids_instock,
                        item.kids_ticket_price,
                        "kids"
                      )}
                      defaultValue={
                        item.kids_executed == 1
                          ? ""
                          : item.kids_ticket_number < 1
                          ? ""
                          : item.kids_ticket_number
                      }
                    />
                    <br />
                    <label className="small-details font-size-13">
                      Estimated revenue: R
                      {item.kids_executed == 1
                        ? 0.0
                        : item.kids_ticket_number == 0
                        ? 0
                        : item.kids_revenues}
                    </label>
                    <br />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div
                className={
                  item.checked == 1
                    ? "item-select-active border-1 mb-3 w-100"
                    : "item-select border-1 mb-3 w-100"
                }
                onClick={() => selected(item.ticketid, item.checked)}
              >
                <div className="w-100 menu-links">
                  <div className="col-12 pl-3 pr-3">
                    <label className="w-100 mb-0">
                      <div className="row align-items-center">
                        <div className="col-lg-1 col-2 col-sm-2 col-md-1 pl-0">
                          {item.checked == 1 ? (
                            <label className="mb-0">
                              <IoIosCheckmarkCircleOutline
                                size={30}
                                className="color-blue"
                              />
                            </label>
                          ) : (
                            <label className="mb-0">
                              <IoIosRadioButtonOff
                                size={30}
                                className="color-blue"
                              />
                            </label>
                          )}
                        </div>
                        <div className="col-lg-11 col-10 col-sm-10 col-md-11 pl-0 pr-0">
                          {item.category == "general" ? (
                            <span>General</span>
                          ) : item.category == "vip" ? (
                            <span>VIP</span>
                          ) : (
                            <span>VVIP</span>
                          )}

                          <br />
                          <label className="small-details mb-0">
                            <ImMan color={"darkorange"} /> Loaded:{" "}
                            {item.initial_load}
                            <br />
                            <FaChild color={"#39c"} /> Loaded:{" "}
                            {item.kids_initial_load}
                          </label>
                          <label
                            className={
                              "float-right mb-0 small-details text-right"
                            }
                          >
                            {item.instock} in stock{" "}
                            <ImMan color={"darkorange"} />
                            <br />
                            {item.kids_instock} in stock{" "}
                            <FaChild color={"#39c"} />
                          </label>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const prepare = () => {
    // const eventid = location.state.eventid;
    const ticketLimit = ticketPrint;
    const costs = ticketPrint * 1;
    // const budget = balance;
    // const balance = budget;
    // alert(balance);
    // return;

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=LOADTEMPORARYTICKETS&eventid=" +
        eventid +
        "&ticketLimit=" +
        ticketLimit +
        "&reprintNumber=" +
        ticketPrint,
      { withCredentials: true }
    ).then((response) => {
      localStorage.setItem("ticketLimit", ticketPrint);
      localStorage.setItem("ticketPrint", ticketPrint);
      localStorage.setItem("estimatedRevenue", estimatedRevenue);
      localStorage.setItem("costs", costs.toFixed(1));
      localStorage.setItem("budget", budget);
      localStorage.setItem("balance", balance);

      history.push({
        pathname: "/ticketdownload",
      });
    });
  };

  const close = () => {
    setErrorDisplay("none");
  };

  if (localStorage.getItem("businessname") === null) {
    return <Redirect to="/login" />;
    //   return exit(1);
  } else {
    if (localStorage.getItem("download") === null) {
      return <Redirect to="/dashboard" />;
    }
  }

  let { prevpage, costs } = "";

  if (!location.state) {
    return <Redirect to="/dashboard" />;
  } else {
    prevpage = location.state.prevpage;
    costs = ticketPrint * 1;
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="view">
      {progressbar && <TopBarProgress />}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="main-content"
        style={{
          marginTop: 40,
          marginLeft: isMob ? "0px" : collapsed ? "60px" : "240px",
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={handleToggle} />
        )}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid pb-5">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-5 pl-0 pr-0">
                    <button
                      onClick={() => history.goBack()}
                      className="link-btn"
                    >
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  <div className="col-lg-8 col-7 text-right pr-2">
                    <label className="back-arrow mb-0">
                      {ticketPrint > 0 && costs < budget ? (
                        <div
                          className="save-btn btn-radius-3 w-auto"
                          onClick={() => prepare()}
                          // style={{ width: 170 }}
                        >
                          <span
                            style={{
                              display: updateDisplay,
                            }}
                          >
                            {" "}
                            {/* Prepare {ticketPrint} tickets */}
                            Prepare download
                          </span>
                          <span
                            style={{
                              display: spinning,
                            }}
                          >
                            <ClipLoader
                              color={"#fff"}
                              loading={true}
                              // css={override}
                              size={20}
                            />
                          </span>
                        </div>
                      ) : (
                        <label class="back-arrow float-right mb-0">
                          <div class="ticket-btn-disabled with-100 text-center mb-0 font-size-15 btn-border-color-grey">
                            <span>Prepare</span>
                          </div>
                        </label>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {parseInt(costs) > parseInt(budget) && costs > 0 ? (
              <div className="col-12 p-0 mb-2 color-red">
                Your balance is too low to print {ticketPrint} tickets.{" "}
                <label className="mb-0 color-blue" onClick={() => increase()}>
                  Increase budget
                </label>{" "}
                or reduce the number.
              </div>
            ) : (
              ""
            )}

            <div className=" BoxDashboardContainer pl-1 pr-1">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0">
                    <label className="ticket-title pl-0 pr-0">
                      PREPARE TICKETS
                    </label>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 details-body pl-0 pr-0">
                <div className="col-lg-12 details-body mb-5">
                  <span>Event</span>
                  <br />
                  <span className="small-details details-body">
                    {localStorage.getItem("eventname")}
                  </span>
                  <br />
                  <br />

                  <label className="mb-0 float-right text-right">
                    <label className="text-bold">
                      Budget:{" "}
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={Number(budget).toFixed(2)}
                        prefix="R"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                      />
                      <br />
                      Balance:{" "}
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={Number(balance).toFixed(2)}
                        prefix="R"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                      />
                    </label>
                    <br />
                    Cost per ticket download:{" "}
                    <label className="small-details"> R1.00</label>
                    <br />
                    Quantity:{" "}
                    <label className="small-details"> {ticketPrint}</label>
                    <br />
                    Total costs:{" "}
                    <label className="small-details"> R{costs}</label>
                    <br />
                    Estimated revenue:{" "}
                    <label className="small-details">
                      {" "}
                      R{estimatedRevenue}
                    </label>
                  </label>
                </div>
                <br />

                <br />
                <br />
                <br />
                <br />
                <div className="col-12">
                  <label className="mb-0 small-details color-black">
                    Select ticket type
                  </label>
                </div>
                {ticketsF()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div
        className={successError}
        style={{ display: errorDisplay, textAlign: "center" }}
        onclick={() => close()}
      >
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Downloadtickets;
